import './index.css'

const CardItem = props => {
  const {features} = props
  const {title, description, imgUrl, className} = features
  return (
    <div className="main-cont">
      <li className={className}>
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="image-cont">
          <img src={imgUrl} alt={title} />
        </div>
      </li>
    </div>
  )
}

export default CardItem
